import { render, staticRenderFns } from "./FacturasVencidasGps.vue?vue&type=template&id=56a2bb26&"
import script from "./FacturasVencidasGps.vue?vue&type=script&lang=js&"
export * from "./FacturasVencidasGps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports